import React, { useState, useEffect } from "react";
import { useNavigate, NavLink, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext.js";
import { getFirestoreData } from "../../firebase/Firestore.js";
import "./Navbar.css";

const options = ["SCULC 2027", "SCULC 2026","SCULC 2025", "SCULC 2024", "SCULC 2023", "SCULC 2022"];

const Navbar = () => {
    const { currentUser, userLoggedIn } = useAuth();
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [navOpen, setNavOpen] = useState(false);

    useEffect(() => {
        const getUserData = async () => {
            if (currentUser) {
                const adminStatus = await getFirestoreData("Users", currentUser.uid, "admin", false);
                setIsAdmin(adminStatus);
            }
        };
        getUserData();
    }, [currentUser]);

    const handleSelect = (option) => {
        const year = option.split(" ")[1]; // Extract year from "SCULC 2025"
        navigate(`/sculc-${year}`);
        setIsDropdownOpen(false);
        setNavOpen(false);
    };

     const handleLinkClick = () => {
        setNavOpen(false);
        setIsDropdownOpen(false);
    };



    return (
    <nav className={`nav ${navOpen ? "open" : ""}`}>
        <Link to="/" className="sitename">
            <img src="/images/bruin-linguists-logo-alt.png" alt="logo" className="logo-image" />
        </Link>

        {/* Hamburger icon (only visible on mobile) */}
        <div className="hamburger" onClick={() => setNavOpen(!navOpen)}>
            ☰
        </div>

        {/* Nav links - hidden on mobile unless navOpen */}
        <div className={`links ${navOpen ? "show" : ""}`}>
            <NavLink
                to="/"
                end
                className={({ isActive }) => `navtitle${isActive ? " active" : ""}`}
                onClick={handleLinkClick}>
                Home
            </NavLink>

            <div className="dropdown-wrapper">
                <div className="sculc navtitle" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    SCULC
                </div>
                {isDropdownOpen && (
                    <ul className="dropdown-menu mobile">
                        {options.map((option, index) => (
                            <li
                                key={index}
                                onClick={() => handleSelect(option)}
                                className="dropdown-item"
                            >
                                {option}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <NavLink
                to="/lingua"
                className={({ isActive }) => `navtitle${isActive ? " active" : ""}`}
                onClick={handleLinkClick}>
                LinguA
            </NavLink>
            <NavLink
                to="/naclo"
                className={({ isActive }) => `navtitle${isActive ? " active" : ""}`}
                onClick={handleLinkClick}>
                NACLO
            </NavLink>
            <NavLink
                to="/board"
                className={({ isActive }) => `navtitle${isActive ? " active" : ""}`}
                onClick={handleLinkClick}>
                Our Board
            </NavLink>

            {userLoggedIn ? (
                <Link to="/profile" className="navtitle" onClick={() => setNavOpen(false)}>Profile</Link>
            ) : (
                <Link to="/login" className="navtitle"  onClick={() => setNavOpen(false)}>Login</Link>
            )}

            {isAdmin && (
                <Link to="/user-data" className="navtitle" onClick={() => setNavOpen(false)}>User Data</Link>
            )}
        </div>
    </nav>
    );
};

export default Navbar;